export default {
    afterLoad(pluginHandler) {
        if( ! pluginHandler.isLoaded('PlusMinusColumn')) {
            pluginHandler.load(['PlusMinusColumn'])
        }
        if( ! pluginHandler.isLoaded('OrderColumn')) {
            pluginHandler.load(['OrderColumn'])
        }
        if( ! pluginHandler.isLoaded('InputColumn')) {
            pluginHandler.load(['InputColumn'])
        }
        if( ! pluginHandler.isLoaded('MarkRequiredColumns')) {
            pluginHandler.load(['MarkRequiredColumns'])
        }
        if( ! pluginHandler.isLoaded('ColumnHints')) {
            pluginHandler.load(['ColumnHints'])
        }
    },
    mixins() {
        return {
            props: {
                displayPlusMinusColumn: {
                    type: Boolean,
                    default: true
                }
            },
            watch: {
                columns: {
                    immediate: true,
                    handler() {
                        let foundPlusMinusColumn = false

                        for (let column of this.$_columns) {
                            if( column.type === undefined && (column.content === undefined || column.content.component === undefined) ) {
                                column.type = 'InputColumn'
                            }

                            if( column.type === 'PlusMinusColumn' ) {
                                foundPlusMinusColumn = true
                            }
                        }

                        if( ! foundPlusMinusColumn && this.displayPlusMinusColumn ) {
                            this.columns.unshift(
                                this.formatColumn({title: "Actions", type: "PlusMinusColumn"})
                            )
                        }
                    }
                }
            },
            created() {
                this.internalTableClasses.push('oc-dtable')
            }
        }
    }
}
